import { useEffect, useState } from 'react';
import TextRenderer, {
  BUSINESS_BANKING_LOWER_RIGHT_RENDER_STRATEGY,
} from '../../../utils/text-renderer';
import { CardPreviewFront, type CardPreviewFrontProps } from './CardPreviewFront';

export interface WithTextRendererProps {
  readonly boundingBox: {
    readonly width: number;
    readonly height: number;
  };
  readonly estimatedFontSize: number;
  readonly fontFamily: string;
  readonly nameOnCard: string;
}

export const WithTextRendererCardPreviewFront = (
  props: Omit<CardPreviewFrontProps, 'signatureDataUri'> & WithTextRendererProps,
) => {
  const [signatureDataUri, setSignatureDataUri] = useState('');
  const [textRenderer, setTextRenderer] = useState<TextRenderer | null>(null);

  const {
    boundingBox, estimatedFontSize, fontFamily, nameOnCard,
  } = props;

  useEffect(() => {
    const txtRenderer = new TextRenderer(
      estimatedFontSize,
      fontFamily,
      nameOnCard,
      boundingBox,
      BUSINESS_BANKING_LOWER_RIGHT_RENDER_STRATEGY,
    );
    setTextRenderer(txtRenderer);
  }, []);

  useEffect(() => {
    if (textRenderer) {
      textRenderer.fontFamily = fontFamily;
      textRenderer.text = nameOnCard;
      setSignatureDataUri(textRenderer.toDataURL());
    }
  }, [textRenderer, nameOnCard, fontFamily]);

  return <CardPreviewFront {...props} signatureDataUri={signatureDataUri} />;
};
